import api from "api";

const participantLikes = {
    like: (slug, participantId) => api().post(`/events/${slug}/participants/${participantId}/like`),
    getStatus: (slug) => api().get(`/events/${slug}/likes/status`),
};

export default participantLikes;
